import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb42e098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shareModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "header-title flex items-center gap-2" }, "Share Advisory", -1))
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "linkPreview" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "snackbar_copy"
}

import { weatherLocation } from '@/states/homeState';
import { createShareLink } from '@/utils/methods/share-link';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareModal',
  props: {
    draw: null
  },
  setup(__props: any) {

const props = __props as { draw: MapboxDraw }


const showModal = ref(false);
const showSuccessCopySnackbar = ref(false);

const copyLink = () => {
  navigator.clipboard.writeText(shareLink());
  showSuccessCopySnackbar.value = true;
  setTimeout(() => {
    showSuccessCopySnackbar.value = false;
  }, 5000);
};

const shareLink = () => createShareLink(props.draw, weatherLocation.value);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModal).value = $event)),
    location: "center center",
    "scroll-strategy": "none",
    "content-class": "align-center"
  }, {
    activator: _withCtx(({ props }) => [
      _renderSlot(_ctx.$slots, "default", { modalProp: props })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = false)),
            class: "close-btn"
          }, [
            _createVNode(_component_Icon, { icon: "mdi:close" })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(" Share this link to the people to share the current airspace information. Copy the link below or share it via whatsapp "),
            _createElementVNode("a", {
              class: "whatsappShareBtn",
              target: "blank",
              href: `https://wa.me/?text=${shareLink()}`
            }, [
              _createVNode(_component_Icon, { icon: "mdi:whatsapp" }),
              _createTextVNode("Share on Whatsapp ")
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("input", {
              type: "text",
              disabled: "",
              class: "link",
              value: shareLink()
            }, null, 8, _hoisted_8),
            _createElementVNode("button", {
              class: "copyBtn",
              onClick: copyLink
            }, [
              _createVNode(_component_Icon, {
                icon: "mdi:link-variant",
                class: "text-sm"
              }),
              _createTextVNode(" Copy ")
            ])
          ]),
          (showSuccessCopySnackbar.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(_component_Icon, {
                  icon: "mdi:check-circle-outline",
                  class: "inline"
                }),
                _createTextVNode(" Link copied "),
                _createElementVNode("button", {
                  class: "v-snackbar-close-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showSuccessCopySnackbar.value = false))
                }, [
                  _createVNode(_component_Icon, { icon: "mdi:close" })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})